var map = {
	"./image-AI-API.png": 71880,
	"./image-API-extract-structured.png": 6733,
	"./image-API-extract.png": 19985,
	"./image-API-interview.png": 3047,
	"./image-API-q&a.png": 41140,
	"./image-API-text-gen.png": 43416,
	"./image-BUIE-AI.png": 52877,
	"./image-BUIE-portal.png": 25605,
	"./image-BUIE-sample.png": 50641
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 39855;